<button
  matButton="outlined"
  type="button"
  class="tw-w-full"
  (click)="edit.emit()"
>
  <mat-icon svgIcon="pencil-sparkle" aria-hidden="true"></mat-icon>
  <strong>Edit layout</strong>
</button>
